import type { Props } from './types';
import type { FieldValuesFromFieldErrors } from '@hookform/error-message';

import type { FieldErrors, FieldName, FieldValues } from 'react-hook-form';

import { ErrorMessage } from '@hookform/error-message';

import {
  formControlVariant,
  formInputVariant,
  formLabelVariant,
} from './configs';

import { cn } from '@/lib/utils';

export const FormControl = <T extends FieldValues>({
  children,
  className,
  // eslint-disable-next-line react/no-unstable-default-props
  errors = {},
  inputClassName,
  inputName,
  isRequired = false,
  label,
  labelClassName,
  notes,
  notesClassName,
  rootInputClassName,
  showErrors = true,
}: Props<T>) => {
  return (
    <div className={cn(formControlVariant(), className)}>
      {
        label && (
          <label
            className={cn(formLabelVariant(), labelClassName)}
            htmlFor={inputName as string}
          >
            {label}
            {
              isRequired && <span className="text-red-500">*</span>
            }
          </label>
        )
      }
      <div className={cn('flex flex-1 flex-col gap-[0.8rem]', rootInputClassName)}>
        <div className={cn(formInputVariant(), inputClassName)}>
          {children}
          {showErrors && inputName && (
            <ErrorMessage
              errors={errors}
              name={
                inputName as unknown as FieldName<
                  FieldValuesFromFieldErrors<FieldErrors<T>>
                >
              }
              render={({ message, messages }) =>
                message
                  ? (
                      <span className="text-sm text-red-500">{message}</span>
                    )
                  : (
                      messages
                      && Object.entries(messages).map(([type, message]) => (
                        <span className="text-sm text-red-500" key={type}>
                          {message}
                        </span>
                      ))
                    )}
            />
          )}
        </div>
        {
          notes && (
            <span className={cn('text-sm', notesClassName)}>{notes}</span>
          )
        }
      </div>
    </div>
  );
};
